import React, { useState } from 'react'
import classes from './MyWork.module.css'

const MyWork = ({ list }) => {

    const [useStyles, setUseStyles] = useState(true)
    const handleButtonClick = (url) => {
        window.location.href = url;
    };

    const styles = {
        borderBottom: '1px solid black',
        display: 'inline-block'
    }

    return (
        <section className={classes.myWork}>
            <div className={classes.myWorkHeader}>
                <h2 style={useStyles ? styles : {}} onMouseEnter={() => setUseStyles(false)} onMouseLeave={() => setUseStyles(true)} className={classes.test} >My Work</h2>
            </div>
            <div className={classes.myWorkBlock}>
                {list.map((items) => {
                    return (
                        <div className={classes.myWorkbox}>
                            <img src={items.img} alt='' />
                            <div className={classes.titleBlock}>
                                <h4 style={{ color: `${items.color}` }}>{items.title}</h4>
                                <button onClick={() => handleButtonClick(items.url)} style={{ backgroundColor: `${items.color}` }}>{items.button}</button>
                            </div>
                        </div>
                    )
                })}
            </div>

        </section>
    )
}

export default MyWork